import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useFileExplorerContext } from "../FileExplorerContext";

export const FileExplorerLoadingOverlay: React.FC = () => {
  const { t } = useTenantTranslation();
  const { isLoading, uploadLoading } = useFileExplorerContext();
  if (!isLoading && !uploadLoading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
        maxHeight: "100vh",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress />
        <Typography variant="body2">{t("processingFiles")}</Typography>
      </Stack>
    </Box>
  );
};
